import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormField = _resolveComponent("FormField")!
  const _component_FormFieldComboBox = _resolveComponent("FormFieldComboBox")!
  const _component_DynamicField = _resolveComponent("DynamicField")!
  const _component_FormFieldCheckbox = _resolveComponent("FormFieldCheckbox")!
  const _component_FormFooter = _resolveComponent("FormFooter")!
  const _component_Page = _resolveComponent("Page")!

  return (_openBlock(), _createBlock(_component_Page, {
    "tab-id": _ctx.selectedTabId,
    "onUpdate:tab-id": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedTabId) = $event)),
    title: _ctx.pageTitle,
    "is-content-loading": _ctx.isContentLoading,
    tabs: _ctx.tabList
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_FormFooter, {
        "back-href": _ctx.backButtonUrl,
        "is-submitting": _ctx.isSubmitting,
        "is-creation": _ctx.isCreation,
        "can-create-another": _ctx.isCreation,
        onSubmit: _ctx.submitForm
      }, null, 8, ["back-href", "is-submitting", "is-creation", "can-create-another", "onSubmit"])
    ]),
    default: _withCtx(() => [
      (_ctx.isCreation)
        ? (_openBlock(), _createElementBlock("form", {
            key: 0,
            novalidate: "",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createVNode(_component_FormField, {
              value: _ctx.values.name,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.values.name) = $event)),
              name: "name",
              error: _ctx.errors.name,
              label: "Название"
            }, null, 8, ["value", "error"]),
            _createVNode(_component_FormField, {
              value: _ctx.values.systemName,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.values.systemName) = $event)),
              name: "systemName",
              label: "Системное название",
              error: _ctx.errors.systemName
            }, null, 8, ["value", "error"]),
            _createVNode(_component_FormFieldComboBox, {
              value: _ctx.values.type,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.values.type) = $event)),
              clearable: true,
              label: "Тип",
              error: _ctx.errors.type,
              name: "type",
              options: _ctx.typeOptionList
            }, null, 8, ["value", "error", "options"])
          ], 32))
        : (_openBlock(), _createElementBlock("form", {
            key: 1,
            novalidate: "",
            onSubmit: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"]))
          }, [
            (_ctx.selectedTabId === 'common')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_FormField, {
                    value: _ctx.values.name,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.values.name) = $event)),
                    name: "name",
                    error: _ctx.errors.name,
                    label: "Название"
                  }, null, 8, ["value", "error"]),
                  _createVNode(_component_FormField, {
                    value: _ctx.values.systemName,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.values.systemName) = $event)),
                    name: "systemName",
                    label: "Системное название",
                    error: _ctx.errors.systemName
                  }, null, 8, ["value", "error"]),
                  _createVNode(_component_FormFieldComboBox, {
                    value: _ctx.values.type,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.values.type) = $event)),
                    clearable: true,
                    label: "Тип",
                    error: _ctx.errors.type,
                    name: "type",
                    options: _ctx.typeOptionList
                  }, null, 8, ["value", "error", "options"]),
                  _createVNode(_component_FormField, {
                    value: _ctx.values.adminNote,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.values.adminNote) = $event)),
                    name: "adminNote",
                    error: _ctx.errors.adminNote,
                    label: "Описание в админке"
                  }, null, 8, ["value", "error"]),
                  _createVNode(_component_FormField, {
                    value: _ctx.values.description,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.values.description) = $event)),
                    name: "description",
                    error: _ctx.errors.description,
                    type: "textarea",
                    label: "Описание для пользователя"
                  }, null, 8, ["value", "error"])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.selectedTabId === 'settings')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_FormField, {
                    value: _ctx.values.yesLabel,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.values.yesLabel) = $event)),
                    name: "yesLabel",
                    error: _ctx.errors.yesLabel,
                    label: "Пользовательское значение при значении \"Да\""
                  }, null, 8, ["value", "error"]),
                  _createVNode(_component_FormField, {
                    value: _ctx.values.noLabel,
                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.values.noLabel) = $event)),
                    name: "noLabel",
                    label: "Пользовательское значение при значении \"Нет\"",
                    error: _ctx.errors.noLabel
                  }, null, 8, ["value", "error"])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.selectedTabId === 'colors')
              ? (_openBlock(), _createBlock(_component_DynamicField, {
                  key: 2,
                  field: _ctx.inputsColorsField,
                  "is-label-hidden": false
                }, null, 8, ["field"]))
              : _createCommentVNode("", true),
            (_ctx.selectedTabId === 'select')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createVNode(_component_FormFieldCheckbox, {
                    checked: _ctx.values.multiple,
                    "onUpdate:checked": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.values.multiple) = $event)),
                    name: "multiple",
                    label: "Множественный выбор",
                    error: _ctx.errors.multiple
                  }, null, 8, ["checked", "error"]),
                  _createVNode(_component_DynamicField, {
                    field: _ctx.inputsSelectField,
                    "is-label-hidden": false
                  }, null, 8, ["field"])
                ], 64))
              : _createCommentVNode("", true)
          ], 32))
    ]),
    _: 1
  }, 8, ["tab-id", "title", "is-content-loading", "tabs"]))
}